import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AppState, Dispatch } from '../../../store/types'
import { bindActionCreators } from 'redux'
// @ts-ignore
import LoadingOverlay from 'react-loading-overlay'

class LoadingWrapper extends Component<Props> {
  render() {
    const { isLoading, child } = this.props
    return (
      <LoadingOverlay active={isLoading} spinner={true} text="Loading...">
        {child}
      </LoadingOverlay>
    )
  }
}
interface Props {
  isLoading: boolean
  child: any
}
const mapStateToProps = (state: AppState) => ({
  isLoading: state.loading.isLoading
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadingWrapper)
